module.exports = __webpack_public_path__ + "static/media/brussels-diversity.d8a2c8ea.jpeg";